angular
    .module("accordionUploadDocuments.components", [])
    .component("accordionUploadDocuments", {
        templateUrl: "ng/components/accordionUploadDocuments/accordionUploadDocuments.view.html",
        bindings: {
            userDaCensire: "=",
            enabledSave: "&"
        },
        controllerAs: "uploadDocumentsCtrl",
        controller: function accordionUploadDocuments(
            $configService,
            $rootScope,
            $timeout,
            $carouslService,
            $typeDomainService,
            Documento,
            $modalService,
            $scope,
            validationService,
            Pf,
            $download,
            $window,
            $istatService,
        ) {
            var self = this;
            var onAfterCarouselChange = function (
                event,
                slick,
                currentSlide,
                nextSlide
            ) {
                if (self.lastIndex && self.lastIndex === currentSlide) {
                    return;
                }

                self.currentSlide = currentSlide;
                self.lastIndex = self.currentSlide;
                self.regExpDocumento = $carouslService.getDocumentType(
                    self.currentSlide
                );

                var tipoDocumento = $carouslService.getDocumentType(self.currentSlide);
                self.userDaCensire.documento.tipo = tipoDocumento;
                self.listaNomeRilascio = Documento.getEntiRilascio(tipoDocumento);

                //Se il numero di enti di rilascio è uguale a 1 lo valorizzo e rendo non editabile
                if (self.listaNomeRilascio.length < 2) {
                    self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio[0];
                }
            };

            var initCarousel = function () {
                $timeout(function () {
                    $(".alba-document-for").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: ".alba-document-carousel",
                        mobileFirst: true,
                        initialSlide: self.indexDocument
                    });

                    $(".alba-document-carousel").slick({
                        slideToShow: 3,
                        slideToScroll: 1,
                        centerMode: true,
                        asNavFor: ".alba-document-for",
                        focusOnSelect: true,
                        infinite: true,
                        variableWidth: true,
                        dots: true,
                        mobileFirst: true,
                        initialSlide: self.indexDocument
                    });

                    $(".alba-document-carousel").on("afterChange", onAfterCarouselChange);
                }, 500);
            };

            var getStati = function () {
                $istatService.getNazioni()
                    .then(function (response) {
                        self.listaNomiStatiNascita = response.domainList;

                        self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                            function (elem) {
                                return elem.name != "ITALIA";
                            }
                        );
                    });
            }

            self.$onInit = (function () {
                self.base64 = null;
                self.link = "";
                self.progress = 0;
                self.frontBase64 = "";
                self.backBase64 = "";
                self.disabledInputCf = false;
                self.disabledInputDoc = false;
                self.mapComuni = $rootScope.comuniMap;
                self.currentCodeTypeNameIndex = 0;
                self.listaProvince = [];
                self.listaNomeComuniRilascio = [];
                self.listaNomeComuniNascita = [];
                self.listaNomiStatiNascita = [];
                self.listaNomeComuniResidenza = [];
                self.listaCap = [];
                self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
                self.today = moment().format("DD/MM/YYYY");
                self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
                self.userDaCensire = self.userDaCensire | {};
                self.documentUpload = [{}];
                self.enabledModifyDocumentDate = false;
                self.currentSlide = 0;
                self.userDaCensire = {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                };
                Object.assign(self.userDaCensire, {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                });

                self.dropdown = {
                    ruolo: [],
                    stati: [],
                    comune: [],
                    statiEsteri: [],
                    entiRilascio: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            "01-01",
                            "06-01",
                            "25-04",
                            "01-05",
                            "02-06",
                            "15-08",
                            "01-11",
                            "08-12",
                            "25-12",
                            "26-12"
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                };

                //albaInit();
                getStati();

                self.onCarouselInit = function () {
                    console.log("carousel init");
                };

                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);

                self.listaProvince.push("EE");

                self.creaComuniRilascio = function (provincia) {
                    self.listaNomeComuniRilascio = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        })
                        .map(function (comuneInProvincia) {
                            return comuneInProvincia.nome;
                        });

                    self.userDaCensire.documento.luogo = "";
                };

                self.creaComuniNascita = function (provincia) {
                    self.listaNomeComuniNascita = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        })
                        .map(function (comuneInProvincia) {
                            return comuneInProvincia.nome;
                        });
                    self.userDaCensire.datiNascita.comune = "";
                };

                self.creaComuniResidenza = function (provincia) {
                    self.userDaCensire.residenza.cap = "";
                    self.userDaCensire.residenza.indirizzo = "";
                    self.userDaCensire.residenza.numeroCivico = "";
                    self.listaNomeComuniResidenza = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        })
                        .map(function (comuneInProvincia) {
                            return comuneInProvincia.nome;
                        });

                    self.userDaCensire.residenza.comune = "";
                };

                self.creaCap = function (comuneNome) {
                    self.comuneDiResidenzaNome = self.mapComuni.filter(function (comune) {
                        return comune.nome.toLowerCase() === comuneNome.toLowerCase();
                    });

                    self.lista = self.comuneDiResidenzaNome.map(function (
                        comuneSelezionato
                    ) {
                        self.listaCap = comuneSelezionato.cap;
                        return self.listaCap;
                    });
                };
                //getRuoli();
                $typeDomainService
                    .getRoles()
                    .then(function (response) {
                        self.dropdown.ruolo = response;
                    })
                    .catch(function (err) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        });
                    });

                $timeout(function () {
                    self.userDaCensire = Pf.build(self.userDaCensire);
                    if (self.userDaCensire.documento.imgDocumentoCf) {
                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCf,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoFront,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoBack,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);
                        self.userDaCensire.isOk = false;

                        self.indexDocument =
                            $carouslService.getIndexByValue(
                                self.userDaCensire.documento.tipo
                            ) || 0;
                        self.listaNomeRilascio = Documento.getEntiRilascio(
                            self.userDaCensire.documento.tipo
                        );
                    }
                    if (self.userDaCensire.documento.tipo) {
                        self.enabledModifyDocumentDate = true;
                        self.regExpDocumento = self.userDaCensire.documento.tipo;
                    }
                    self.disabledUploadDocument();

                    //RN:12378303
                    self.userDaCensire.firmatario.spid = 'N';    

                    initCarousel();
                }, 1);
            })(
                (self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                })
            );

            self.deletePrivacyDocument = function (item, typeDocument) {
                self.progresso = 100;
                if (typeDocument === 'imgCf') {
                    self.disabledInputCf = true;
                    $timeout(function () {
                        self.disabledInputCf = false;
                    }, 5000);
                } else {
                    self.disabledInputDoc = true;
                    $timeout(function () {
                        self.disabledInputDoc = false;
                    }, 5000);
                }
                $timeout(function () {
                    self.progresso = 0;
                }, 200);
                var documentRow =
                    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.selected != true;
                });
                //self.uploader.onCancelItem();
                if (typeDocument === "imgCf") {
                    self.userDaCensire.documento.imgDocumentoCf = "";
                } else {
                    //check front
                    var testFront = self.documentUpload.some(function (elem) {
                        return elem.name === self.userDaCensire.documento.imgDocumentoFront;
                    });
                    if (!testFront) {
                        self.userDaCensire.documento.imgDocumentoFront = "";
                    }

                    //check back
                    var testBack = self.documentUpload.some(function (elem) {
                        return elem.name === self.userDaCensire.documento.imgDocumentoBack;
                    });
                    if (!testBack) {
                        self.userDaCensire.documento.imgDocumentoBack = "";
                    }
                }
                self.disabledUploadDocument();

            };

            self.check = function (el) {
                el.selected = !el.selected;
                if (!self.userDaCensire.firmatario.selected) {
                    self.userDaCensire.telefono = "";
                    self.userDaCensire.firmatario.ruolo = "";
                    self.userDaCensire.email = "";
                } else if (!self.userDaCensire.titolare.selected) {
                    self.userDaCensire.titolare.pep = "No";
                }
            };

            self.generateDownloadLink = function (name) {
                console.log(name);
                var url =
                    "/uni/download/service-infos/" +
                    encodeURIComponent(self.userDaCensire.cf) +
                    "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                    name +
                    "/PERSONAL_DOCUMENTS/";

                $download.getGenericDownload(url)
                    .then(function (response) {
                        console.log(response);
                    })


            }

            self.enabledTrashRemovePdf = function () {
                return self.documentUpload.some(function (element) {
                    return element.selected === true;
                });
            };

            self.leastDocumentUpload = function () {
                var ritorno = false;

                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgDocument" && element.name;
                });
                return ritorno;
            };

            self.leastDocumentCfUpload = function () {
                var ritorno = false;
                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgCf";
                });
                return ritorno;
            };

            self.enteRilascioSelezionato = function (ente) {
                self.userDaCensire.documento.numero = "";
                if (ente.name === "MINISTERO") {
                    self.regExpDocumento = "UCO";
                } else if (ente.name === "DIPARTIM. TRASPORTI TERRESTI") {
                    self.regExpDocumento = "PAM";
                } else if (ente.name === "PREFETTURA") {
                    self.regExpDocumento = "PAT";
                }
                console.log(ente);
            };

            self.listaEntiRilascio = function (preserveData) {
                if (preserveData) {
                    return;
                }

                self.userDaCensire.documento.tipo = "";
                self.userDaCensire.documento.numero = "";
                self.userDaCensire.documento.enteRilascio = "";
                self.userDaCensire.documento.luogo = "";
                self.userDaCensire.documento.provincia = "";
                self.userDaCensire.documento.dataRilascio = "";
                self.userDaCensire.documento.dataScadenza = "";
                self.userDaCensire.documento.imgDocumentoFront = "";
                self.userDaCensire.documento.imgDocumentoBack = "";
                self.userDaCensire.documento.enteRilascio = "";

                self.enabledModifyDocumentDate = true;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != "imgDocument";
                });
                self.disabledUploadDocument();
            };

            self.savePfData = function (pf) {
                console.log(pf);
                pf.isOk = true;
                $modalService.closeModal("censusPerson");
                $(".financial-leasing__footer").css("z-index", "2");
                self.modalShow = false;
                pf = Pf.build(pf);
                self.enabledSave({
                    Pf: pf
                });
            };
            self.undoDocumentChanges = function (pf) {
                pf.isOk = false;
                $modalService.closeModal("censusPerson");
                $(".financial-leasing__footer").css("z-index", "2");
                self.enabledSave({
                    Pf: pf
                });
            };

            self.getEndDate = function (dataRilascio) {
                if (dataRilascio) {
                    var tipoDocumento = self.userDaCensire.documento.tipo;
                    var dataNascita = self.userDaCensire.datiNascita.data;

                    if (dataRilascio) {
                        var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                        var startYear = moment(dataRilascio).format("YYYY");
                        var startDay = moment(dataRilascio).format("DD");
                        var startMonth = moment(dataRilascio).format("MM");

                        var endDate = moment(dataRilascio)
                            .add(10, "years")
                            .format("DD/MM/YYYY");

                        //console.log("Data Scadenza Futura: " + moment(endDate).format('DD/MM/YYYY'));

                        if (
                            tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                            tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                            tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                            tipoDocumento === propMap["DOC_TYPE_PAT"]
                        ) {
                            var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                            var birthYear = moment(dataNascita).format("YYYY");
                            var birthDay = moment(dataNascita).format("DD");
                            var birthMonth = moment(dataNascita).format("MM");

                            if (birthMonth == '02' && birthDay == '29') {
                                birthMonth = '03';
                                birthDay = '01';
                            }

                            var futureBirthDay = moment(
                                birthDay + "/" + birthMonth + "/" + startYear,
                                "DD/MM/YYYY"
                            )
                                .add(10, "years")
                                .format("DD/MM/YYYY");
                            //console.log("Compleanno Futuro: " + futureBirthDay);

                            var daysDiff = moment
                                .duration(
                                    moment(endDate, "DD/MM/YYYY").diff(
                                        moment(futureBirthDay, "DD/MM/YYYY")
                                    )
                                )
                                .asDays();

                            var expiryDate;
                            if (daysDiff <= 0) {
                                expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                                    "DD/MM/YYYY"
                                );
                            } else {
                                expiryDate = moment(
                                    birthDay + "/" + birthMonth + "/" + startYear,
                                    "DD/MM/YYYY"
                                )
                                    .add(11, "years")
                                    .format("DD/MM/YYYY");
                            }

                            if (
                                moment
                                    .duration(
                                        moment(
                                            self.userDaCensire.documento.dataScadenza,
                                            "DD/MM/YYYY"
                                        ).diff(moment(expiryDate, "DD/MM/YYYY"))
                                    )
                                    .asDays() > 0
                            ) {
                                $scope.pfForm.dataScadenza.$valid = false;
                            }
                            return expiryDate;
                        } else {
                            if (
                                moment
                                    .duration(
                                        moment(
                                            self.userDaCensire.documento.dataScadenza,
                                            "DD/MM/YYYY"
                                        ).diff(moment(endDate, "DD/MM/YYYY"))
                                    )
                                    .asDays() > 0
                            ) {
                                $scope.pfForm.dataScadenza.$valid = false;
                            }
                            return endDate;
                        }
                    } else {
                        return moment(self.today, "DD/MM/YYYY")
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                    }
                }
                return moment(self.today, "DD/MM/YYYY")
                    .add(10, "years")
                    .format("DD/MM/YYYY");
            };

            self.validateForm = function () {
                var checkUploadFound = false;
                if (
                    self.userDaCensire &&
                    self.userDaCensire.documento &&
                    self.userDaCensire.documento.imgDocumentoCf &&
                    self.userDaCensire.documento.imgDocumentoFront &&
                    self.userDaCensire.documento.imgDocumentoBack
                ) {
                    checkUploadFound =
                        self.userDaCensire.documento.imgDocumentoCf &&
                        self.userDaCensire.documento.imgDocumentoFront &&
                        self.userDaCensire.documento.imgDocumentoBack;
                }
                return $scope.pfForm.$valid && checkUploadFound;
            };

            self.getTodaysDate = function () {
                return moment().format("DD/MM/YYYY");
            };

            self.uploadForOcr = function (typeDoc, idSelected, face) {
                self.progresso = 0;
                var typeDocument = "";
                if (typeDoc === "imgDocument") {
                    typeDocument = self.userDaCensire.documento.tipo;
                    self.disabledInputDoc = true;
                } else {
                    typeDocument = "CF";
                    self.disabledInputCf = true;
                }

                self.documentUpload.push({
                    name: "",
                    type: "",
                    selected: false,
                    waitFromLink: false,
                    downloadLink: ""
                });
                var x = null;
                var file = document.querySelector("input[id=" + idSelected + "]")
                    .files[0];
                var reader = new FileReader();
                var inputGenerale = {
                    inputNextOcr: {},
                    uniUploadRestPojo: {
                        type: "PERSONAL_DOCUMENTS",
                        idObject: self.userDaCensire.cf,
                        fileName: file.name
                    }
                };
                reader.onload = function () {
                    var x = reader.result;
                    var y = x.indexOf("base64") + 7;
                    var n = x.substr(y);
                    self.base64 = n;
                    var input = {
                        checkSignature: "",
                        frontStringBase64: "",
                        backStringBase64: "",
                        documentType: typeDocument
                    };
                    if (typeDoc === "imgCf") {
                        self.userDaCensire.documento.imgDocumentoCf = file.name;
                        input = {
                            checkSignature: "",
                            frontStringBase64: "",
                            backStringBase64: self.base64,
                            documentType: typeDocument
                        };
                        inputGenerale.inputNextOcr = input;
                    } else {
                        if (face === "f") {
                            self.frontBase64 = self.base64;
                            self.userDaCensire.documento.imgDocumentoFront = file.name;
                            input = {
                                checkSignature: "",
                                frontStringBase64: self.base64,
                                backStringBase64: "",
                                documentType: typeDocument
                            };
                        } else {
                            self.backBase64 = self.base64;
                            self.userDaCensire.documento.imgDocumentoBack = file.name;
                            input = {
                                checkSignature: "",
                                frontStringBase64: "",
                                backStringBase64: self.base64,
                                documentType: typeDocument
                            };
                        }
                        if (self.backBase64 != "" && self.frontBase64 != "") {
                            input = {
                                checkSignature: "",
                                frontStringBase64: self.frontBase64,
                                backStringBase64: self.backBase64,
                                documentType: typeDocument
                            };

                        } else {
                            $timeout(function () {
                                self.progresso = 100;
                            }, 4500);
                            $timeout(function () {
                                self.documentUpload[self.documentUpload.length - 1].name =
                                    file.name;
                                self.documentUpload[
                                    self.documentUpload.length - 1
                                ].type = typeDoc;
                                self.documentUpload[self.documentUpload.length - 1].downloadLink = $configService.getAppConfig().url +
                                    "/uni/download/service-infos/" +
                                    encodeURIComponent(self.userDaCensire.cf) +
                                    "/PERSONAL_DOCUMENTS/" + file.name +
                                    "/PERSONAL_DOCUMENTS/?token=" +
                                    $configService.getAppConfig().token;
                                self.documentUpload[
                                    self.documentUpload.length - 1
                                ].waitFromLink = true;
                            }, 4000);
                            $timeout(function () {
                                self.disabledInputDoc = false;
                            }, 8000)
                            $('#' + idSelected).val('');
                            return;
                        }
                        inputGenerale.inputNextOcr = input;
                    }
                    $timeout(function () {
                        self.progresso = 100;
                    }, 2000);
                    $typeDomainService
                        .ocrIdentityDocument(inputGenerale)
                        .then(function (response) {
                            console.log(self.userDaCensire);
                            self.userDaCensire = Pf.build(self.userDaCensire);
                            console.log(response);

                            switch (response.tipo) {
                                case 'CAI':
                                    self.userDaCensire.documento.numero = self.userDaCensire.documento.numero ?
                                        self.userDaCensire.documento.numero :
                                        response.cardNumber;
                                    self.userDaCensire.documento.dataRilascio = response.dataRilascio ?
                                        moment(response.dataRilascio).format("DD/MM/YYYY") :
                                        self.yesterday;
                                    self.userDaCensire.documento.dataScadenza = response.dataScadenza ?
                                        moment(response.dataScadenza).format("DD/MM/YYYY") :
                                        moment().add(3, "days").format("DD/MM/YYYY");

                                    break;

                                case 'NCE':
                                    self.userDaCensire.documento.numero = self.userDaCensire.documento.numero ?
                                        self.userDaCensire.documento.numero :
                                        response.numero;
                                    self.userDaCensire.documento.dataRilascio = response.dataRilascio ?
                                        moment(response.dataRilascio).format("DD/MM/YYYY") :
                                        self.yesterday;
                                    self.userDaCensire.documento.dataScadenza = response.dataScadenza ?
                                        moment(response.dataScadenza).format("DD/MM/YYYY") :
                                        moment().add(3, "days").format("DD/MM/YYYY");
                                    self.userDaCensire.documento.luogo = self.userDaCensire.documento.luogo ?
                                        self.userDaCensire.documento.luogo :
                                        response.issuingPlace;

                                    break;

                                case 'PAT':
                                    self.userDaCensire.documento.numero = self.userDaCensire.documento.numero ?
                                        self.userDaCensire.documento.numero :
                                        response.numero;
                                    self.userDaCensire.documento.dataRilascio = response.dataRilascio ?
                                        moment(response.dataRilascio).format("DD/MM/YYYY") :
                                        self.yesterday;
                                    self.userDaCensire.documento.dataScadenza = response.dataScadenza ?
                                        moment(response.dataScadenza).format("DD/MM/YYYY") :
                                        moment().add(3, "days").format("DD/MM/YYYY");
                                    self.userDaCensire.documento.luogo = self.userDaCensire.documento
                                        .luogo;
                                    if (response.issuingPlace.split("-")[1] != "UCO") {

                                        self.userDaCensire.documento.provincia = self.userDaCensire.documento.provincia ?
                                            self.userDaCensire.documento.provincia :
                                            response.issuingPlace.split("-")[1];
                                    }
                                    if (response.issuingPlace.split("-")[0] === "MC" || response.issuingPlace.split("-")[0] === "MTCT") {
                                        self.userDaCensire.documento.enteRilascio = {
                                            name: "DIPARTIM. TRASPORTI TERRESTI"
                                        };
                                    } else if (response.issuingPlace.split("-")[0] === "MIT") {
                                        self.userDaCensire.documento.enteRilascio = {
                                            name: "MINISTERO"
                                        };
                                    } else {
                                        self.userDaCensire.documento.enteRilascio = {
                                            name: "PREFETTURA"
                                        };
                                    }

                                    break;
                                case 'PAS':
                                    self.userDaCensire.documento.numero = self.userDaCensire.documento.numero ?
                                        self.userDaCensire.documento.numero :
                                        response.cardNumber;
                                    self.userDaCensire.documento.dataRilascio = response.dataRilascio ?
                                        moment(response.dataRilascio).format("DD/MM/YYYY") :
                                        self.yesterday;
                                    self.userDaCensire.documento.dataScadenza = response.dataScadenza ?
                                        moment(response.dataScadenza).format("DD/MM/YYYY") :
                                        moment().add(3, "days").format("DD/MM/YYYY");
                                    break;

                                default:
                                    break;
                            }

                            // DA CAPIRE BENE COME INTEGRARE I DATI CHE ARRIVANO DAL SERVIZIO

                            self.userDaCensire.nome = self.userDaCensire.nome ?
                                self.userDaCensire.nome :
                                response.firstName;
                            self.userDaCensire.cognome = self.userDaCensire.cognome ?
                                self.userDaCensire.cognome :
                                response.lastName;
                            self.userDaCensire.cf = self.userDaCensire.cf ?
                                self.userDaCensire.cf :
                                response.codiceFiscale;
                            self.userDaCensire.sesso = self.userDaCensire.sesso ?
                                self.userDaCensire.sesso :
                                response.gender;

                            self.userDaCensire.datiNascita.data = self.userDaCensire.datiNascita.data ?
                                self.userDaCensire.datiNascita.data :
                                moment(response.dateOfBirth).format("DD/MM/YYYY");
                            self.userDaCensire.datiNascita.comune =
                                self.userDaCensire.datiNascita.comune;
                            self.userDaCensire.datiNascita.provincia =
                                self.userDaCensire.datiNascita.provincia ? self.userDaCensire.datiNascita.provincia : response.provincia;

                            self.userDaCensire.documento.enteRilascio =
                                self.userDaCensire.documento.enteRilascio;

                            self.userDaCensire.documento.provincia = self.userDaCensire.documento.provincia
                            self.userDaCensire.documento.tipo =
                                self.userDaCensire.documento.tipo;
                            self.userDaCensire.documento.imgDocumentoCf =
                                self.userDaCensire.documento.imgDocumentoCf;
                            self.userDaCensire.documento.imgDocumentoBack =
                                self.userDaCensire.documento.imgDocumentoBack;
                            self.userDaCensire.documento.imgDocumentoFront =
                                self.userDaCensire.documento.imgDocumentoFront;

                            self.userDaCensire.residenza.indirizzo = self.userDaCensire.residenza.indirizzo ?
                                self.userDaCensire.residenza.indirizzo :
                                response.addressStreet.split(",")[0];
                            self.userDaCensire.residenza.numeroCivico = self.userDaCensire
                                .residenza.numeroCivico ?
                                self.userDaCensire.residenza.numeroCivico :
                                response.addressStreet.split(",")[1];
                            self.userDaCensire.residenza.comune = self.userDaCensire.residenza.comune ?
                                self.userDaCensire.residenza.comune :
                                response.addressLocality;
                            self.userDaCensire.residenza.provincia = self.userDaCensire.residenza.provincia ?
                                self.userDaCensire.residenza.provincia :
                                response.addressProvince;

                            self.userDaCensire.titolare.selected =
                                self.userDaCensire.titolare.selected;

                            self.userDaCensire.firmatario.selected =
                                self.userDaCensire.firmatario.selected;
                            self.userDaCensire.firmatario.ruolo =
                                self.userDaCensire.firmatario.ruolo;

                            self.userDaCensire.email = self.userDaCensire.email;
                            self.userDaCensire.telefono = self.userDaCensire.telefono;

                            $timeout(function () {
                                if (typeDoc === 'imgCf') {
                                    self.userDaCensire.documento.imgDocumentoCf = response.imgCf;
                                    self.documentUpload[self.documentUpload.length - 1].name = response.imgCf;
                                    self.documentUpload[self.documentUpload.length - 1].downloadLink =
                                        $configService.getUrl() +
                                        "/uni/download/service-infos/" +
                                        encodeURIComponent(self.userDaCensire.cf) +
                                        "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                                        self.documentUpload[self.documentUpload.length - 1].name +
                                        "/PERSONAL_DOCUMENTS/?token=" +
                                        $configService.getAppConfig().token;
                                    self.documentUpload[self.documentUpload.length - 1].type = typeDoc;
                                    self.documentUpload[
                                        self.documentUpload.length - 1
                                    ].waitFromLink = true;
                                } else {
                                    self.userDaCensire.documento.imgDocumentoFront = response.imgDocFirmatario1;
                                    self.documentUpload[self.documentUpload.length - 1].name = response.imgDocFirmatario1;
                                    self.documentUpload[self.documentUpload.length - 1].downloadLink =
                                        $configService.getUrl() +
                                        "/uni/download/service-infos/" +
                                        encodeURIComponent(self.userDaCensire.cf) +
                                        "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                                        self.documentUpload[self.documentUpload.length - 1].name +
                                        "/PERSONAL_DOCUMENTS/?token=" +
                                        $configService.getAppConfig().token;
                                    self.documentUpload[self.documentUpload.length - 1].type = typeDoc;
                                    self.documentUpload[
                                        self.documentUpload.length - 1
                                    ].waitFromLink = true;
                                    self.userDaCensire.documento.imgDocumentoBack = response.imgDocFirmatario2;
                                    self.documentUpload[self.documentUpload.length - 2].name = response.imgDocFirmatario2;
                                    self.documentUpload[self.documentUpload.length - 2].downloadLink =
                                        $configService.getUrl() +
                                        "/uni/download/service-infos/" +
                                        encodeURIComponent(self.userDaCensire.cf) +
                                        "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                                        self.documentUpload[self.documentUpload.length - 2].name +
                                        "/PERSONAL_DOCUMENTS/?token=" +
                                        $configService.getAppConfig().token;
                                    self.documentUpload[self.documentUpload.length - 2].type = typeDoc;
                                    self.documentUpload[
                                        self.documentUpload.length - 2
                                    ].waitFromLink = true;
                                }
                                self.disabledUploadDocument();
                            }, 2000);
                        })
                        .catch(function (err) { })
                        .finally(function () {
                            if (typeDoc === 'imgCf') {

                                $timeout(function () {
                                    self.disabledInputCf = false;
                                }, 5000);
                            } else {
                                $timeout(function () {
                                    self.disabledInputDoc = false;
                                }, 5000);
                            }

                            self.creaComuniNascita(self.userDaCensire.datiNascita.provincia);
                            self.creaCap(self.userDaCensire.residenza.comune);
                            self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                            $('#' + idSelected).val('');
                        });
                };
                if (file) {
                    reader.readAsDataURL(file);
                }

            };

            self.verifyDate = function () {
                self.testDati = true;

                if (
                    self.userDaCensire &&
                    self.userDaCensire.datiNascita &&
                    self.userDaCensire.datiNascita.comune
                ) {
                    var codCat;
                    if (self.userDaCensire.datiNascita.comune.name) {
                        codCat = self.userDaCensire.datiNascita.comune.value;
                    } else {
                        var x = self.mapComuni.find(function (elem) {
                            return elem.nome === self.userDaCensire.datiNascita.comune;
                        });

                        codCat = x.codiceCatastale;
                    }

                    self.testDati = validationService.checkCfWithFieds(
                        self.userDaCensire.cf,
                        self.userDaCensire.nome,
                        self.userDaCensire.cognome,
                        self.userDaCensire.datiNascita.data,
                        self.userDaCensire.sesso,
                        codCat
                    );

                    if (!self.testDati) {
                        if (typeof $scope.pfForm.userCf != "undefined") {
                            $scope.pfForm.userCf.$setValidity("userCf", false);
                        }
                    } else {
                        if (typeof $scope.pfForm.userCf != "undefined") {
                            $scope.pfForm.userCf.$setValidity("userCf", true);
                        }
                    }
                } else {
                    self.testDati = false;
                }
            };

            self.disabledUploadDocument = function () {
                if (self.uploadDocumenti === "imgCf") {
                    self.uploadCfCompleted = false;
                } else {
                    self.uploadDocCompleted = false;
                    self.frontBase64 = "";
                    self.backBase64 = "";
                }
                self.disabledUploadCf = self.documentUpload.some(function (elem) {
                    return elem.type === "imgCf";
                });

                var temp = 0;

                self.documentUpload.forEach(function (elem) {
                    if (elem.type === "imgDocument") {
                        temp++;
                    }

                    if (temp >= 2) {
                        self.disabledUploadDocIdent = true;
                    } else {
                        self.disabledUploadDocIdent = false;
                    }
                });
            };

        }
    });